var $export = require('./_export');
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', {defineProperties: require('./_object-dps')});


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/core-js/modules/es6.object.define-properties.js
// module id = ../../../../core-js/modules/es6.object.define-properties.js
// module chunks = 0